<template>
  <div class="home">
    <h1 style="display: none">Sustentabilidad: Construyendo un Futuro Sostenible para una empresa con proposito</h1> 
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  metaInfo: {
    title: 'Asesoría en la medición del impacto ambiental | Green Solutions',
    meta: [
      { name: 'description', content: 'Un Futuro Sostenible con Green Solutions es posible. Brindamos soluciones sustentables en gestión ambiental, huella de carnbono y agua y reducción de emisiones. Únete a nosotros y construyamos un futuro más verde y próspero. Contáctanos hoy mismo.' }
    ]
  },
  components: {
    HelloWorld
  }
}
</script>
